
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hi/gallery",
      function () {
        return require("private-next-pages/hi/gallery.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hi/gallery"])
      });
    }
  